import { cn } from "@/lib/utils";
import FeedCreatePost from "@/modules/community/components/feed/feed-create-post";
import FeedHomePage from "@/modules/community/components/feed/feed-homepage";
import { useCommunityContext } from "@/providers/community-provider";
import { CreatePostModalProvider } from "@/providers/modal-provider";

const HottestDiscussions = () => {
	const { communityInfo } = useCommunityContext();
	const communitySlug = communityInfo?.slug;
	const isPublicFeed = true;

	return (
		<div>
			<div className="mb-6 grid gap-6 md:grid-cols-2">
				<h2
					className={cn(
						"relative text-3xl font-bold text-gray-700",
						"after:absolute after:-bottom-2 after:left-0 after:h-1 after:w-20 after:bg-blue-500 after:content-['']"
					)}
				>
					Hottest Discussions!
				</h2>

				<p className="text-lg text-gray-500">
					Engage in the best proptech conversations from around the world and explore opportunities.
				</p>
			</div>
			<div className="flex w-full flex-col space-y-4 overflow-hidden">
				<CreatePostModalProvider>
					<FeedCreatePost />
					<FeedHomePage
						isPublicFeed={isPublicFeed}
						communitySlug={communitySlug}
						channelSlug={undefined}
					/>
				</CreatePostModalProvider>
			</div>
		</div>
	);
};

export default HottestDiscussions;
